const ACCESS_TOKEN_KEY = 'auth.accessToken';
const REFRESH_TOKEN_KEY = 'auth.refreshToken';
const USER_KEY = 'auth.user';

export function getAccessToken() {
  return localStorage.getItem(ACCESS_TOKEN_KEY);
}

export function getRefreshToken() {
  return localStorage.getItem(REFRESH_TOKEN_KEY);
}

export function getCurrentUser() {
  try {
    const user = localStorage.getItem(USER_KEY);
    return user ? JSON.parse(user) : null;
  } catch (e) {
    return null;
  }
}

export function isAuthenticated() {
  return Boolean(getAccessToken() && getRefreshToken() && getCurrentUser());
}

export function isAdmin() {
  return ['ADMIN', 'SYSTEM'].includes(getCurrentUser()?.role);
}

export function setAuthSession({ accessToken, refreshToken, user }) {
  const previousUser = getCurrentUser();
  if (previousUser?.id && user?.id && previousUser.id !== user.id) {
    localStorage.removeItem('user_profile');
  }
  localStorage.setItem(ACCESS_TOKEN_KEY, accessToken);
  localStorage.setItem(REFRESH_TOKEN_KEY, refreshToken);
  localStorage.setItem(USER_KEY, JSON.stringify(user));
  window.dispatchEvent(new Event('auth-changed'));
}

export function updateStoredUser(user) {
  localStorage.setItem(USER_KEY, JSON.stringify(user));
  window.dispatchEvent(new Event('auth-changed'));
}

export function clearAuthSession() {
  localStorage.removeItem(ACCESS_TOKEN_KEY);
  localStorage.removeItem(REFRESH_TOKEN_KEY);
  localStorage.removeItem(USER_KEY);
  localStorage.removeItem('isAuthenticated');
  localStorage.removeItem('user_profile');
  window.dispatchEvent(new Event('auth-changed'));
}
